import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'Taja Bazzar';
const DEFAULT_DESCRIPTION =
  'Taja Bazzar connects local farmers in Morang, Sunsari, and Jhapa with consumers for fresh, direct farm-to-table produce in eastern Nepal.';
const SITE_URL = 'https://tajabazzar.me';

export default function PageMeta({ title, description, path = '', type = 'website' }) {
  const pageTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
  const pageDescription = description || DEFAULT_DESCRIPTION;
  const canonical = `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`;

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />
    </Helmet>
  );
}
